import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-654be6ed"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-guide" }
const _hoisted_2 = { class: "order-guide-content estimate1" }
const _hoisted_3 = ["src"]

import { ref, reactive, computed } from 'vue'
import data from '../data'
import { useStore } from 'vuex'
import { useSite, isJA, isD2C } from '@/store'

export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String,
    default: ''
  }
},
  emits: ['calllback'],
  setup(__props, { emit }) {

const props = __props

const store = useStore()

const computedIndex: any = ref(0)
const next: any = () => {
  computedIndex.value++
}
const info: any = computed(() => {
  return data[props.name][computedIndex.value]
})
const showGuide: any = computed(() => {
  return false
  // 日本才有新手引导
  // return !store.state.guide.guideState[props.name] && isJA()
})
const isLogin = computed(() => store.getters.isLogin)
const close = () => {
  store.dispatch('guide/changeGuideStatus', { key: props.name, value: true })
  emit('calllback')
}

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        style: {"widows":"100%","height":"100%"},
        referrerPolicy: "no-referrer",
        src: `https://static-s.theckb.com/BusinessMarket/guide/${_unref(isD2C)() ? 'D2C' : 'B2B'}-${_unref(useSite)()}.jpg?xxx=1`,
        alt: ""
      }, null, 8, _hoisted_3),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).stepBtn, (i, k) => {
        return (_openBlock(), _createElementBlock("div", {
          style: _normalizeStyle({
        height: i.height,
        width: i.width,
        top: i.top,
        left: i.left,
      }),
          key: k,
          class: "step-btn",
          onClick: next
        }, null, 4))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(info).returnBtn, (i, k) => {
        return (_openBlock(), _createElementBlock("div", {
          style: _normalizeStyle({
        height: i.height,
        width: i.width,
        top: '50%',
        left: i.left,
      }),
          key: k,
          class: "return-btn",
          onClick: close
        }, null, 4))
      }), 128))
    ])
  ], 512)), [
    [_vShow, _unref(showGuide) && _unref(isLogin)]
  ])
}
}

})